import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
} from "@material-ui/core";
import useStyles from "./style";
import { useState } from "react";
import {
  useData,
  utilityCollection,
} from "../../../../components/firebase/DataProvider";
import { FieldValue } from "../../../../components/firebase/FirebaseProvider";

function DialogPembayaran({
  open,
  handleClose,
  alamatId,
  is_payment_code,
  is_payment_name,
  data,
}) {
  const classes = useStyles();
  const { integrasionPayments, mootaConfig, cartRef } = useData();
  const [pelajari, setPelajari] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transferBank, setTranferBank] = useState(true);
  const [listProviderMidtrans, setLlistProviderMidtrans] = useState([]);
  const [choosedPayment, setChoosedPayment] = useState({
    code: "",
    name: "",
  });

  // const {
  //   is_active = false,
  //   maxRand,
  //   minRand,
  //   operator,
  //   usedNumbers,
  // } = mootaConfig;

  useEffect(() => {
    async function getMidtransPaymentList() {
      try {
        setChoosedPayment({
          code: is_payment_code,
          name: is_payment_name,
        });
        if (listProviderMidtrans?.length > 0) {
          return;
        } else {
          const midtransPaymentList = await utilityCollection
            .doc("midtrans_payment_list")
            .get();
          const isMultiplier = midtransPaymentList?.data()?.data;
          setLlistProviderMidtrans(Object.entries(isMultiplier ?? []));
        }
      } catch (error) {
        console.log("error get multiplier ", error.message);
      }
    }
    getMidtransPaymentList();
  }, [is_payment_code, is_payment_name]);

  const handleChoosePayment = async () => {
    setLoading(true);
    let totalPembayaran = data?.total_pembayaran ?? 0;
    let uniqueCode = 0;
    const isPaymentCode = `transfer_${choosedPayment?.code}`;
    const isUsed = mootaConfig?.usedNumbers.indexOf(totalPembayaran) >= 0;

    if (choosedPayment?.name === is_payment_name) {
      setLoading(false);
      return handleClose();
    }

    if (choosedPayment?.code === "midtrans") {
      const isTotalPembayaran = data?.total_pembayaran_before_is_payment
        ? data?.total_pembayaran_before_is_payment
        : data?.total_pembayaran;
      try {
        const myData = {
          subcarts: {
            [alamatId]: {
              total_pembayaran: isTotalPembayaran,
              total_pembayaran_before_is_payment: FieldValue.delete(),
            },
          },
          unique_code: FieldValue.delete(),
          is_payment_code: "midtrans",
          is_payment_name: "midtrans",
          updated_at: FieldValue.serverTimestamp(),
        };
        await cartRef.set(myData, { merge: true });
        setLoading(false);
        return handleClose();
      } catch (error) {
        console.log(error.message);
      }
    } else {
      if (isUsed) {
        uniqueCode = parseInt(
          Math.random() * (mootaConfig?.maxRand - mootaConfig?.minRand + 1) + mootaConfig?.minRand
        );
        mootaConfig?.operator === "+"
          ? (totalPembayaran += uniqueCode)
          : (totalPembayaran -= uniqueCode);
        try {
          const myData = {
            subcarts: {
              [alamatId]: {
                total_pembayaran_before_is_payment: data?.total_pembayaran,
                total_pembayaran: totalPembayaran,
              },
            },
            unique_code: uniqueCode,
            is_payment_code: isPaymentCode,
            is_payment_name: choosedPayment?.name,
            updated_at: FieldValue.serverTimestamp(),
          };
          await cartRef.set(myData, { merge: true });
          setLoading(false);
          return handleClose();
        } catch (error) {
          console.log(error.message);
        }
      } else {
        try {
          const myData = {
            unique_code: uniqueCode,
            is_payment_code: isPaymentCode,
            is_payment_name: choosedPayment?.name,
            updated_at: FieldValue.serverTimestamp(),
          };
          await cartRef.set(myData, { merge: true });
          setLoading(false);
          return handleClose();
        } catch (error) {
          console.log(error.message);
        }
      }
    }
  };

  return (
    <Dialog
      fullScreen
      PaperProps={{
        style: {
          maxWidth: 960,
        },
      }}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        {" "}
        <div style={{ display: "flex" }}>
          <ArrowBackIcon
            onClick={handleClose}
            style={{ marginRight: "20px", cursor: "pointer" }}
          />
          <Typography
            style={{
              fontSize: 18,
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            Metode Pembayaran
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: "0px" }}>
        <div style={{ margin: "20px" }}>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              setChoosedPayment({
                code: "midtrans",
                name: "midtrans",
              });
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "90%" }}>
                <Typography className={classes.liquidPrimaryTitle}>
                  Midtrans
                </Typography>
                <Typography className={classes.liquidSmallSize}>
                  Tersedia 25 metode untuk kemudahan pelanggan lakukan
                  pembayaran online.{" "}
                  <span
                    style={{ color: "#5675D3" }}
                    onClick={() => {
                      setPelajari(!pelajari);
                    }}
                  >
                    Selengkapnya
                  </span>
                </Typography>
              </div>
              {choosedPayment?.code === "midtrans" ? (
                <div>
                  <CheckCircleOutlineIcon
                    style={{
                      fontSize: "20px",
                    }}
                    color="primary"
                  />
                </div>
              ) : null}
            </div>
            {pelajari ? (
              <div>
                <Typography
                  style={{ marginBottom: "10px", marginTop: "10px" }}
                  className={classes.liquidSmallGrey}
                >
                  Jenis Pembayaran
                </Typography>
                {listProviderMidtrans?.map(([title, items], key) => {
                  return (
                    <div style={{ marginLeft: "10px" }}>
                      <Typography className={classes.liquidSmall}>
                        <FiberManualRecordIcon
                          style={{
                            fontSize: "12px",
                            color: "grey",
                            marginRight: "10px",
                          }}
                        />{" "}
                        {title}{" "}
                        {items?.length > 0 && items?.join(", ") !== ""
                          ? `: ${items?.join(", ")}`
                          : ""}
                      </Typography>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
          {mootaConfig?.is_active ? (
            <>
              <Divider
                style={{
                  marginTop: 20,
                  marginBottom: 10,
                  marginLeft: -20,
                  marginRight: -20,
                }}
              />
              <div
                style={{ display: "flex", justifyContent: "space-between" }}
                onClick={() => setTranferBank(!transferBank)}
              >
                <Typography className={classes.liquidPrimaryTitle}>
                  Transfer Bank
                </Typography>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {choosedPayment?.code &&
                  choosedPayment?.code !== "midtrans" ? (
                    <CheckCircleIcon
                      style={{
                        fontSize: "20px",
                        marginRight: 10,
                      }}
                      color="primary"
                    />
                  ) : null}
                  {transferBank ? (
                    <ExpandLessIcon style={{ cursor: "pointer" }} />
                  ) : (
                    <ExpandMoreIcon style={{ cursor: "pointer" }} />
                  )}
                </div>
              </div>
              <Divider
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  marginLeft: -20,
                  marginRight: -20,
                }}
              />
              {transferBank ? (
                <>
                  {integrasionPayments?.map((item, index) => {
                    return (
                      <>
                        {index > 0 && (
                          <Divider
                            style={{
                              marginTop: 20,
                              marginBottom: 20,
                              marginLeft: -20,
                              marginRight: -20,
                            }}
                          />
                        )}{" "}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            margin: 15,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // console.log("wwadid");
                            setChoosedPayment({
                              code: item?.id,
                              name: item?.name,
                            });
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div style={{ marginRight: 15 }}>
                              <img
                                style={{ width: 40 }}
                                src={item?.logoUrl}
                                alt="logo"
                              />
                            </div>
                            <Typography className={classes.liquidPrimaryTitle}>
                              {item?.name}
                            </Typography>
                          </div>
                          {choosedPayment?.code !== "midtrans" &&
                          choosedPayment?.name === item?.name ? (
                            <div>
                              <CheckCircleOutlineIcon
                                style={{
                                  fontSize: "20",
                                }}
                                color="primary"
                              />
                            </div>
                          ) : null}
                        </div>
                      </>
                    );
                  })}
                </>
              ) : null}
            </>
          ) : null}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="small"
          fullWidth
          color="primary"
          disabled={loading}
          onClick={handleChoosePayment}
        >
          Konfirmasi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogPembayaran;
